import moment from 'moment';

const normalizeHomePlaylist = response => {
  const { data } = response.data;
  if (data && data.length > 0) {
    var playlistsData;
    var videoData;
    data.map(({ attributes: { playlists } }) => {
      if (playlists && playlists.length > 0) {
        playlistsData = playlists
          .map(playlist => {
            const {
              id,
              type,
              attributes: {
                title,
                description,
                shortDescription,
                sortOrder,
                iconUrl,
                isDark,
                images: { cover, thumbnails }
              }
            } = playlist;
            return {
              id,
              title,
              sortOrder,
              description,
              shortDescription: shortDescription || '',
              iconUrl: iconUrl || '',
              cover: cover,
              thumbnails: thumbnails,
              isDark: isDark || 0,
              isActive: false,
              type
            };
          })
          .sort((a, b) => a.sortOrder - b.sortOrder);
      }
    });

    data.map(({ attributes: { videos } }) => {
      if (videos && videos.length > 0) {
        // const {
        //   id,
        //   attributes: { title, streamSourceUrl, source, images: { thumbnails } }
        // } = videos[0];
        // videoData = { id, title, streamSourceUrl, source, thumbnails };
        videoData = videos
          .map(vid => {
            const {
              id,
              attributes: {
                title,
                contentType,
                displayOrder,
                description,
                streamSourceUrl,
                source,
                images: { cover, thumbnails }
              }
            } = vid;
            return {
              id,
              title,
              title,
              contentType,
              displayOrder,
              description,
              streamSourceUrl,
              source,
              cover: cover,
              thumbnails: thumbnails
            };
          })
          .sort((a, b) => a.displayOrder - b.displayOrder);
      }
    });
    return {
      playlists: playlistsData ? playlistsData : [],
      videos: videoData ? videoData : []
    };
  }
  return [];
};

const normalizeHomeVideo = response => {
  const { data } = response.data;
  if (data && data.length > 0) {
    const result = data.map(({ attributes: { videos } }) =>
      videos
        .map(video => {
          const {
            id,
            type,
            attributes: {
              title,
              description,
              streamSourceUrl,
              permission,
              subtitles,
              shortDescription,
              displayOrder,
              isDark,
              startTime,
              endTime,
              images: {
                cover: {
                  // title: coverTitle,
                  background: coverBG,
                  backgroundColor: coverBGColor
                },
                thumbnails: { preview, cover }
              },
              homeTeamId,
              awayTeamId
            }
          } = video;
          return {
            id,
            title,
            streamSourceUrl,
            permission,
            subtitles,
            description,
            displayOrder,
            startTime,
            endTime,
            shortDescription: shortDescription || '',
            // coverTitle: coverTitle,
            background: coverBG,
            backgroundColor: coverBGColor || '#000622',
            isDark: isDark || 0,
            thumbnails: {
              preview,
              cover
            },
            type,
            homeTeamId: homeTeamId ? homeTeamId : null,
            awayTeamId: awayTeamId ? awayTeamId : null
          };
        })
        .sort((a, b) => a.displayOrder - b.displayOrder)
    );
    return result;
  }
  return [];
};

const normalizeVodPlaylist = response => {
  const { data } = response.data;
  if (data && data.length > 0) {
    var playlistsData;
    var videoData;
    data.map(({ attributes: { playlists } }) => {
      if (playlists && playlists.length > 0) {
        playlistsData = playlists
          .map(playlist => {
            const {
              id,
              type,
              attributes: {
                title,
                description,
                shortDescription,
                sortOrder,
                iconUrl,
                isDark,
                images: { cover, thumbnails }
              }
            } = playlist;
            return {
              id,
              title,
              sortOrder,
              description,
              shortDescription: shortDescription || '',
              iconUrl: iconUrl || '',
              cover: cover,
              thumbnails: thumbnails,
              isDark: isDark || 0,
              isActive: false,
              type
            };
          })
          .sort((a, b) => a.sortOrder - b.sortOrder);
      }
    });

    data.map(({ attributes: { videos } }) => {
      if (videos && videos.length > 0) {
        videoData = videos
          .map(video => {
            const {
              id,
              type,
              attributes: {
                title,
                description,
                streamSourceUrl,
                permission,
                subtitles,
                shortDescription,
                displayOrder,
                isDark,
                startTime,
                endTime,
                images: {
                  cover: {
                    // title: coverTitle,
                    background: coverBG,
                    backgroundColor: coverBGColor
                  },
                  thumbnails: { preview, cover }
                }
              }
            } = video;
            return {
              id,
              title,
              streamSourceUrl,
              permission,
              subtitles,
              description,
              displayOrder,
              startTime,
              endTime,
              shortDescription: shortDescription || '',
              // coverTitle: coverTitle,
              background: coverBG,
              backgroundColor: coverBGColor || '#000622',
              isDark: isDark || 0,
              thumbnails: {
                preview,
                cover
              },
              type
            };
          })
          .sort((a, b) => a.displayOrder - b.displayOrder);
      }
    });

    return {
      playlists: playlistsData ? playlistsData : [],
      videos: videoData ? videoData : []
    };
  }
  return [];
};

const normalizeHistory = response => {
  const { data } = response.data;
  if (data && data.length > 0) {
    return data.map(movieHistory => {
      const historyId = movieHistory.id;
      const attr = movieHistory.attributes;
      const timePosition = attr.timePosition;
      const videoId = attr.videoId;
      return attr.videos.map(({ attributes }) => {
        const { title, coverUrl, duration, chapter, thumbnail } = attributes;

        return {
          historyId,
          videoId,
          timePosition,
          title,
          chapter: chapter,
          thumbnail: thumbnail ? thumbnail[0] : coverUrl,
          duration: duration || 0
        };
      });
    });
  }
  return {
    meta: {
      status: 'no_result'
    },
    data: []
  };
};

const normalizeSearchResult = response => {
  const { data } = response.data;
  if (data && data.length > 0) {
    return data.map(result => {
      const {
        id,
        type,
        attributes: {
          title,
          year,
          // thumbnail,
          coverUrl,
          name,
          imageUrl
        }
      } = result;

      if (type == 'videos') {
        return {
          id,
          type,
          title,
          year,
          coverUrl
        };
      } else {
        return {
          id,
          type,
          name,
          imageUrl
        };
      }
    });
  }
  return [];
};

const normalizeSearchGenre = response => {
  const { data } = response.data;
  if (data && data.length > 0) {
    return data.map(({ attributes: { playlists } }) =>
      playlists.map(({ id, attributes }) => {
        const { title, iconUrl } = attributes;
        return {
          id,
          title,
          iconUrl
        };
      })
    );
  }
  return [];
};

const normalizeRecentSearch = response => {
  const { data } = response.data;
  if (data && data.length > 0) {
    return data.map(({ id, attributes: { keyword } }) => {
      return {
        id,
        keyword
      };
    });
  }
  return [];
};

const normalizeVideoDetail = response => {
  const { data } = response.data;
  if (data && data.length > 0) {
    return data.map(result => {
      const {
        id,
        attributes: {
          title,
          contentType,
          images,
          quotes,
          trailers,
          description,
          source,
          drm,
          streamSourceUrl,
          subtitles,
          people,
          isDark,
          year,
          duration,
          playlists,
          startTime,
          endTime
        }
      } = result;
      const filteredSubtitles = subtitles.map(subtitle => {
        const { id, type, attributes: { locale, url, format } } = subtitle;
        /* More info please visit https://support.theoplayer.com/hc/en-us/articles/214041829-TextTrack-API */
        return {
          id,
          format /* srt, emsg, eventstream, ttml, webvtt */,
          locale,
          type /* subtitles, captions, descriptions, chapters, metadata */,
          url
        };
      });
      return {
        id,
        title,
        contentType,
        quotes,
        trailers,
        description,
        source,
        drm,
        streamSourceUrl,
        subtitles: filteredSubtitles,
        people,
        isDark,
        year,
        duration,
        images,
        playlists,
        startTime,
        endTime
      };
    });
  }
  return [];
};

const normalizeMovieLibrary = response => {
  const { data } = response.data;
  if (data && data.length > 0) {
    return data.map(({ attributes: { videos, title: genreTitle } }) =>
      videos.map(({ id, attributes }) => {
        const { title, thumbnail, coverUrl } = attributes;
        return {
          genreTitle,
          id,
          title,
          thumbnail: thumbnail || coverUrl
        };
      })
    );
  }
  return {
    meta: {
      status: 'no_result'
    },
    data: []
  };
};

const normalizeVideoStream = response => {
  const { data } = response.data;
  if (data && data.length > 0) {
    return data.map(result => {
      const { id, attributes: { streamSourceUrl, subtitles } } = result;
      return {
        id,
        streamSourceUrl,
        subtitles
      };
    });
  }
  return [];
};

const normalizeSeriesVideos = response => {
  const { data } = response.data;
  if (data && data.length > 0) {
    const playlistId = data[0].id;
    const playlistTitle = data[0].attributes.title;
    const images = data[0].attributes.images;
    const description = data[0].attributes.description;
    return data.map(({ attributes: { videos } }) => {
      const episodeTotal = videos ? videos.length : 0;
      let videosDt = [];
      if (videos) {
        videosDt = videos
          .map(vid => {
            const {
              id,
              attributes: {
                title,
                description,
                streamSourceUrl,
                displayOrder,
                images: { cover, thumbnails },
                viewsCount,
                likesCount
              }
            } = vid;
            return {
              id,
              title,
              description,
              streamSourceUrl,
              displayOrder,
              cover: cover,
              thumbnails: thumbnails,
              viewsCount,
              likesCount,
              playlistTitle
            };
          })
          .sort((a, b) => a.displayOrder - b.displayOrder);
      }

      return {
        id: playlistId,
        title: playlistTitle,
        description,
        episodeTotal,
        cover: images.cover,
        thumbnails: images.thumbnails,
        videos: videosDt
      };
    });
  }
  return [];
};

const normalizeProgrammeGuides = response => {
  const { data } = response.data;
  if (data && data.length > 0) {
    return data.map(result => {
      const {
        id,
        attributes: {
          start,
          end,
          title,
          description,
          playlist: { attributes: playlistAttributes },
          video: { attributes: videoAttributes }
        }
      } = result;

      return {
        id,
        start: moment(start)
          .utcOffset(7)
          .format(), // parse to WIB
        end,
        title,
        description,
        playlist: playlistAttributes,
        video: videoAttributes
      };
    });
  }
  return [];
};

const normalizeBanner = response => {
  const { data } = response.data;
  if (data && data.length > 0) {
    return data[0].attributes.banners.map(result => {
      const { id, attributes: { name, link, imageUrl } } = result;
      return {
        id,
        imageUrl,
        link,
        name
      };
    });
  }
};

const normalizeMatchDetail = response => {
  const { data } = response.data;
  if (data && data.length > 0) {
    return data.map(result => {
      const {
        id,
        type,
        attributes: {
          title,
          homeTeam,
          awayTeam,
          description,
          streamSourceUrl,
          permission,
          subtitles,
          shortDescription,
          displayOrder,
          isDark,
          startTime,
          endTime,
          images: {
            cover: {
              // title: coverTitle,
              background: coverBG,
              backgroundColor: coverBGColor
            },
            thumbnails: { preview, cover }
          }
        }
      } = result;
      return {
        id,
        type,
        title,
        description,
        streamSourceUrl,
        permission,
        subtitles,
        shortDescription,
        displayOrder,
        isDark,
        startTime,
        endTime,
        shortDescription: shortDescription || '',
        background: coverBG,
        backgroundColor: coverBGColor || '#000622',
        isDark: isDark || 0,
        thumbnails: {
          preview,
          cover
        },
        homeTeam:
          homeTeam && homeTeam.length > 0
            ? { id: homeTeam[0].id, ...homeTeam[0].attributes }
            : null,
        awayTeam:
          awayTeam && awayTeam.length > 0
            ? { id: awayTeam[0].id, ...awayTeam[0].attributes }
            : null
      };
    });
  }
  return [];
};

const normalizeArticlesDetail = response => {
  const { data } = response.data;
  if (!data.attributes.video) {
    const {
      id,
      type,
      attributes: {
        title,
        imageUrl,
        imageCaption,
        author,
        content,
        createdAt,
        metaDescription,
        lists,
        metaKeywords,
        metaTitle,
        readTime,
        summary,
        tags,
        videoAsCover
      }
    } = data;
    return {
      id,
      type,
      title,
      imageUrl,
      imageCaption,
      author,
      content,
      createdAt,
      metaDescription,
      lists,
      metaKeywords,
      metaTitle,
      readTime,
      summary,
      tags,
      videoAsCover,
      video: null
    };
  }
  if (data) {
    const {
      id,
      type,
      attributes: {
        title,
        imageUrl,
        imageCaption,
        author,
        content,
        createdAt,
        metaDescription,
        lists,
        metaKeywords,
        metaTitle,
        readTime,
        summary,
        tags,
        videoAsCover,
        video
      }
    } = data;
    return {
      id,
      type,
      title,
      imageUrl,
      imageCaption,
      author,
      content,
      createdAt,
      metaDescription,
      lists,
      metaKeywords,
      metaTitle,
      readTime,
      summary,
      tags,
      videoAsCover,
      video
    };
  }
  return null;
};

const normalizeNewArticles = response => {
  const { data } = response.data;
  if (data) {
    const result = data.map(article => {
      const {
        id,
        type,
        attributes: {
          title,
          author,
          imageUrl,
          content,
          createdAt,
          metaDescription,
          lists,
          metaKeywords,
          metaTitle,
          readTime,
          summary,
          tags,
          videoAsCover
        }
      } = article;
      return {
        id,
        type,
        title,
        imageUrl,
        author,
        content,
        createdAt,
        metaDescription,
        lists,
        metaKeywords,
        metaTitle,
        readTime,
        summary,
        tags,
        videoAsCover
      };
    });

    return result;
  }
};

const normalizeRecommendedArticles = response => {
  const { data } = response.data;
  if (data) {
    const result = data.attributes.articles.map(article => {
      const {
        id,
        type,
        attributes: {
          title,
          author,
          imageUrl,
          content,
          createdAt,
          metaDescription,
          lists,
          metaKeywords,
          metaTitle,
          readTime,
          summary,
          tags,
          videoAsCover
        }
      } = article;
      return {
        id,
        type,
        title,
        imageUrl,
        author,
        content,
        createdAt,
        metaDescription,
        lists,
        metaKeywords,
        metaTitle,
        readTime,
        summary,
        tags,
        videoAsCover
      };
    });
    if (data.attributes.title) {
      return {
        title: data.attributes.title,
        articles: result
      };
    }
    return result;
  }
};

const normalizeVideoIdList = response => {
  const { data } = response.data;
  if (data && data.length > 0) {
    const result = data.map(({ attributes: { videos } }) =>
      videos.map(video => {
        const { id } = video;
        return {
          id
        };
      })
    );
    return result;
  }
  return [];
};

export default {
  normalizeHomePlaylist,
  normalizeHomeVideo,
  normalizeVodPlaylist,
  // normalizeVODVideo,
  normalizeHistory,
  normalizeSearchResult,
  normalizeSearchGenre,
  normalizeRecentSearch,
  normalizeVideoDetail,
  normalizeMovieLibrary,
  normalizeVideoStream,
  normalizeSeriesVideos,
  normalizeProgrammeGuides,
  normalizeBanner,
  normalizeArticlesDetail,
  normalizeRecommendedArticles,
  normalizeMatchDetail,
  normalizeVideoIdList,
  normalizeNewArticles
};
